/*
/c-1-24
/xxxxx/c-1-22
/xxxxx/yyyy/c-2-343244
*/

function getCategoryIdFromUrl(url: string): string | null {
    const regMatcher = matchingRegEx();

    const match = url.match(regMatcher);
    if (match && match.length === 2) {
        return match[1].replace(/-/g, '_');
    }
    return null;
}

function matchingRegEx(): RegExp {
    // Create new one every time - RegEx is stateful.
    const categoriesRegEx = /c-([\d,-]+)/i;
    return new RegExp(categoriesRegEx);
}

export default {
    getCategoryIdFromUrl,
    matchingRegEx
};
